<template>
  <NotificationText v-bind="$props">
    <template #primary>
      {{filesLength}} {{files}} von <i>{{peerName}}</i> empfangen
    </template>
    <template v-if="notification.data.description" #secondary>
      {{notification.data.description}}
    </template>
    <template #detail-content>
      <PeerFiles
        :files="notification.data.files"
        :description="notification.data.description"
        :notification-id="notification.id"
      />
    </template>
    <template v-if="actionsSecondary && !serviceWorkerSupported" #actions>
      <v-btn text small color="primary" @click="show">Anzeigen</v-btn>
    </template>
  </NotificationText>
</template>

<script>
  import PeerNotificationTextMixin from './peer-notification-text-mixin';
  import {show as showNotification} from '../notification-utils';
  import {serviceWorkerSupported} from '../../../assets/js/utils';


  export default {
    name: 'PeerFilesReceived',

    mixins: [
      PeerNotificationTextMixin
    ],

    data: () => ({
      serviceWorkerSupported
    }),

    methods: {
      show() {
        showNotification(this.notification);
      }
    }
  };
</script>
